import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Ribbon, Zap } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { api } from "../lib/api";
import { Loader } from "../components/Loader";
import { PageHeader } from "../components/PageHeader";

export default function Subscription() {
  const { user } = useAuth();
  const [settings, setSettings] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api("/subscription/settings").then(setSettings).catch(() => setSettings({})); }, []);

  const subscribe = async () => {
    setBusy(true);
    try {
      const res = await api("/payments/tlync/initiate", { method: "POST", body: JSON.stringify({ purpose: "subscription", phone: user?.phone || "0910000000", email: user?.email || "" }) });
      if (res.redirect_url) window.location.href = res.redirect_url;
    } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };

  if (!settings) return <Loader />;
  const until = user?.subscription_active_until ? new Date(user.subscription_active_until) : null;

  return (
    <div className="animate-fade-in-up max-w-lg mx-auto">
      <PageHeader title="الاشتراك الشهري" />
      <div className="rounded-3xl p-6 bg-gradient-to-l from-[#7C5CFF] to-[#A78BFA] text-white brand-shadow-md">
        <Ribbon size={32} />
        <p className="text-2xl font-black mt-3">{Number(settings.monthly_price || 0).toFixed(2)} د.ل / شهر</p>
        <p className="opacity-90 mt-1">{settings.duration_days || 30} يوم</p>
        {until && <p className="text-sm bg-white/20 rounded-xl px-3 py-2 mt-3">{user?.subscription_active ? `اشتراكك نشط حتى ${until.toLocaleDateString("ar")}` : "اشتراكك منتهي"}</p>}
      </div>
      {settings.enabled === false ? (
        <p className="text-center text-[#6B7280] mt-6">الاشتراك غير مفعّل حالياً</p>
      ) : (
        <button data-testid="subscribe-btn" disabled={busy} onClick={subscribe} className="w-full flex items-center justify-center gap-2 h-14 rounded-2xl bg-[#FF3D5A] text-white font-black mt-6 disabled:opacity-60"><Zap size={20} /> {busy ? "..." : "اشترك الآن عبر T-Lync"}</button>
      )}
    </div>
  );
}
